import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Spin,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axios from "../../../../components/utils/Interceptors";

const { TextArea } = Input;

const GeneralTab = ({ storeInfo }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [logoFileList, setLogoFileList] = useState([]);
  const [faviconFileList, setFaviconFileList] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (storeInfo) {
      form.setFieldsValue({
        store_name: storeInfo.store_name,
        store_description: storeInfo.store_description || "",
        store_name_ar: storeInfo.store_name_ar || storeInfo.store_name,
        store_description_ar: storeInfo.store_description_ar || "",
      });

      if (storeInfo.store_logo) {
        setLogoFileList([
          {
            uid: "-1",
            name: "logo.png",
            status: "done",
            url: storeInfo.store_logo,
          },
        ]);
      }

      if (storeInfo.store_favicon) {
        setFaviconFileList([
          {
            uid: "-2",
            name: "favicon.png",
            status: "done",
            url: storeInfo.store_favicon,
          },
        ]);
      }
    }
  }, [storeInfo, form]);

  const onFinish = async (values) => {
    setLoading(true);

    const formdata = new FormData();
    const fields = {
      store_name: values.store_name,
      store_description: values.store_description,
      store_name_ar: values.store_name_ar,
      store_description_ar: values.store_description_ar,
    };

    Object.entries(fields).forEach(([key, value]) =>
      formdata.append(key, value)
    );

    if (logoFileList[0]?.originFileObj) {
      formdata.append("logo", logoFileList[0].originFileObj);
    }
    if (faviconFileList[0]?.originFileObj) {
      formdata.append("favicon", faviconFileList[0].originFileObj);
    }

    try {
      const baseUrl = process.env.REACT_APP_APIURL;
      const res = await axios.patch(
        `${baseUrl}/vendor/updatestoredetails`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = res.data;
      if (response.status_code === 200) {
        toast.success("Updated Successfully!");
        window.location.reload();
      } else {
        toast.error(response.message || "Update failed");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Spin size="large" className="w-full flex justify-center" />;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      className="max-w-2xl"
    >
      <Form.Item
        label={t("Store_Name")}
        name="store_name"
        rules={[{ required: true }]}
      >
        <Input disabled />
      </Form.Item>

      <Form.Item
        label={`${t("Store_Name")} ${t("in Arabic")}`}
        name="store_name_ar"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("Store_Description")}
        name="store_description"
        rules={[{ max: 100 }]}
      >
        <TextArea showCount maxLength={100} rows={4} />
      </Form.Item>

      <Form.Item
        label={`${t("Store_Description")} ${t("in Arabic")}`}
        name="store_description_ar"
        rules={[{ max: 100 }]}
      >
        <TextArea showCount maxLength={100} rows={4} />
      </Form.Item>

      <Form.Item label={`${t("Logo")} (80 x 56)`} name="logo">
        <Upload
          listType="picture"
          beforeUpload={() => false}
          fileList={logoFileList}
          onChange={({ fileList }) => setLogoFileList(fileList)}
        >
          <Button icon={<UploadOutlined />}>{t("Upload")}</Button>
        </Upload>
      </Form.Item>

      <Form.Item label={`${t("Favicon")} (32 x 32)`} name="favicon">
        <Upload
          listType="picture"
          beforeUpload={() => false}
          fileList={faviconFileList}
          onChange={({ fileList }) => setFaviconFileList(fileList)}
        >
          <Button icon={<UploadOutlined />}>{t("Upload")}</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <button type="submit" className="btn btn-primary text-white">
          {t("vd_pc_btn")}
        </button>
      </Form.Item>
    </Form>
  );
};

export default GeneralTab;
